import AbstractService from "./abstract.service"
import AccountTransformer, { baseUri } from "@/transformers/account.transformer"
import { iriToUuid, toIri } from "./helper"

export const baseUrl = "/api/accounts"

class AccountService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: AccountTransformer })
  }

  trialBegin(iri) {
    if (!iri) return

    return this.patch(`${baseUrl}/trial-begin/${iriToUuid(iri)}`, {
      transformer: AccountTransformer,
      needsAuth: true
    })
  }

  getIri(uuid) {
    return toIri(this.baseUri, uuid)
  }
}

const accountService = new AccountService()
export default accountService
